export default 'proposals'